import React from 'react';

const VisibilitySlash = ({ stroke, ...props }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.5 4.15591L19.5 20.6559"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.5219 15.1809C13.8337 15.8114 12.9333 16.1595 12 16.1559C11.2431 16.1558 10.504 15.9267 9.87975 15.4987C9.25552 15.0707 8.77542 14.4638 8.50256 13.7578C8.2297 13.0518 8.17686 12.2798 8.35098 11.5432C8.5251 10.8067 8.91803 10.14 9.47812 9.63092"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M6.9375 6.83716C3.1125 8.76841 1.5 12.4059 1.5 12.4059C1.5 12.4059 4.5 19.1559 12 19.1559C13.7574 19.1702 15.4929 18.7653 17.0625 17.9747"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M19.5563 16.259C21.6 14.4309 22.5 12.4059 22.5 12.4059C22.5 12.4059 19.5 5.65591 12 5.65591C11.3498 5.65462 10.7007 5.70794 10.0594 5.81528"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.7031 8.72156C13.5006 8.87266 14.2273 9.27906 14.7735 9.87941C15.3198 10.4798 15.6559 11.2415 15.7313 12.0497"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default VisibilitySlash;
